<script>
	import { base } from '$app/paths';

	import { siteTitle } from '$lib/stores/nav';
	import { onMount } from 'svelte';

	const items = [
		{
			title: 'Was ist Crowdsourcing?',
			description:
				'<p>Crowdsourcing bezeichnet die Auslagerung (Outsourcing) von Aufgaben, die traditionell innerhalb einer Organisation erledigt werden, an eine Gruppe interessierter Menschen (crowd – englisch für Menschenmenge) auf freiwilliger Basis. Crowdsourcing ermöglicht völlig neue Wege des Wissenstransfers zwischen Institutionen und der Öffentlichkeit.</p><p>An etlichen großen Bibliotheken spielt Crowdsourcing schon seit mehreren Jahren eine bedeutende Rolle (z. B. Library of Congress, New York Public Library, Österreichische Nationalbibliothek) und hat innovative Ideen und Formate der Zusammenarbeit hervorgebracht.</p>',
		},
		{
			title: 'Warum gibt es diese Crowdsourcing-Aktion?',
			description:
				'<p>Das Ziel dieser Crowdsourcing-Aktion ist es, einen jeweils ausgewählten Bestand der Wienbibliothek im Rathaus, der bislang (nicht zuletzt aufgrund der oft schwer lesbaren individuellen Handschriften und der heute nicht mehr verwendeten Kurrentschrift) nur teilweise erschlossen ist, durch interessierte Personen bearbeiten zu lassen, um ihn danach besser verfügbar zu machen.<p>',
		},
		{
			title: 'An wen richtet sich diese Crowdsourcing-Aktion?',
			description:
				'<p>Die Initiative richtet sich an all jene, die aktiv an der Erschließung des historischen Bestands mitarbeiten möchten. Teilweise sind Kurrentkenntnisse notwendig. Die Webseite ist darüber hinaus auch für Personen gedacht, die die Bestände einfach ansehen und durchsuchen möchten.</p>',
		},
		{
			title: 'Was kann ich mit den Briefen machen?',
			description:
				'<p>Sie können die Briefe transkribieren, Transkriptionen anderer Beiträger*innen prüfen und verbessern oder die fertig transkribierten Briefe lesen.</p>',
		},
		{
			title: 'Was ist Transkribieren?',
			description: `<p>Einen Brief transkribieren heißt, ihn in lesbarer Form abzuschreiben. Unsere Regeln für das Transkribieren finden Sie auf der Seite <a href="${base}/transkriptionsregeln/">Transkriptionsregeln</a>.</p>`,
		},
		{
			title: 'Nach welchen Regeln soll ich transkribieren?',
			description: `<p>Ausführliche Transkriptionsregeln finden Sie auf der Seite <a href="${base}/transkriptionsregeln/">Transkriptionsregeln</a>.</p>`,
		},
		{
			title: 'Welche Rechtschreibung soll zur Anwendung kommen?',
			description: `<p>Die Briefe sollen in der Originalrechtschreibung und Originalschreibweise transkribiert werden. Unleserliche Worte werden als „[…]“ übertragen. Im Original vorliegende Rechtschreibfehler und Abkürzungen (wie z. B. „Mit frdl. Gruße Ihr erg. E.") sollen nicht ergänzt bzw. korrigiert werden, da sie auch über soziale Herkunft und Bildungsgrad der Absender*innen oder medienspezifische Kommunikationspraktiken etwas aussagen. Jede neue Zeile im Original soll auch mit einer neuen Zeile (Entertaste) in der Abschrift beginnen. Detaillierte Transkriptionsregeln finden Sie auf der Seite <a href="${base}/transkriptionsregeln/">Transkriptionsregeln</a>.</p>`,
		},
		{
			title: '“Bereits in Bearbeitung“: Warum können manche Briefe nicht transkribiert werden?',
			description:
				'<p>Viele Briefe umfassen mehrere Seiten und können eventuell nicht auf einmal transkribiert werden. Alle Beiträger*innen haben die Möglichkeit, bis zu fünf Briefe für maximal sieben Tage zu reservieren, um später an der Transkription weiterzuarbeiten. Sollten Sie es nicht schaffen, einen reservierten Brief innerhalb von sieben Tagen zu bearbeiten, wird der Brief zur weiteren Transkription für andere Beiträger*innen freigegeben.</p>',
		},
		{
			title: 'Wie oft wird ein Brief geprüft?',
			description:
				'<p>Wenn ein Brief von anderen Beiträger*innen dreimal geprüft und als korrekt bestätigt wurde, ist die Transkription abgeschlossen und der Brief steht zum Lesen zur Verfügung. Wenn Sie in einer Transkription Fehler entdecken, verbessern Sie den Text und erstellen eine neue Version, die wiederum geprüft werden kann und erst nach dreimaliger Bestätigung als korrekt ausgewiesen wird.</p>',
		},
		{
			title: 'Was mache ich, wenn ich einen Fehler in einem Beitrag gefunden habe?',
			description:
				'<p>Stoßen Sie bei der Aufgabe „Prüfen“ auf einen Fehler, korrigieren Sie ihn bitte und erstellen so nach dem Speichern eine neue Version.</p>',
		},
		{
			title: 'Prüfen Mitarbeiter*innen der Wienbibliothek im Rathaus die Beiträge?',
			description:
				'<p>Nein. Die Qualitätskontrolle der Transkriptionen ist eine Aufgabe, die einen zentralen Bestandteil jeder Crowdsourcing-Aktion darstellt und von den Beiträger*innen übernommen wird. Dies entspricht dem Verständnis von Crowdsourcing, bei dem Beiträger*innen Verantwortung für sich und andere übernehmen und so wesentlich zum Gelingen einer Aktion beitragen.</p>',
		},
		{
			title: 'Wie finde ich einen bestimmten Brief?',
			description:
				'<p>Sie können die Briefe nach folgenden Kriterien filtern:</p><ul><li>Person (Verfasser*innen und Empfänger*innen)</li><li>Datum bzw. Zeitraum</li><li>Aufgabe: Transkribieren, Prüfen oder Lesen</li></ul><p>Unter „Suche“ können Sie in den Metadaten die Absender*innen, Empfänger*innen und Absendeorte aller Briefe suchen. Außerdem können Sie die Inhalte der bereits transkribierten Briefe durchsuchen.</p>',
		},
		{
			title: 'Kann ich die Briefe weiterverwenden?',
			description:
				'<p>Die zur Transkription zur Verfügung gestellten Korrespondenzen kommen aus der <a href="https://digital.wienbibliothek.at/" target="_blank" rel="noreferrer">Wienbibliothek Digital</a>. Diese Korrespondenzen sind alle urheberrechtsfrei und können somit frei weiterverwendet werden. Im Rahmen der üblichen wissenschaftlichen Gepflogenheiten bitten wir Sie bei einer Vervielfältigung oder Verwertung um Namensnennung der Wienbibliothek im Rathaus als besitzende Institution und um Angabe der URN.</p>',
		},
		{
			title: 'Warum nicht A-Z?',
			description:
				'<p>Derzeit digitalisieren wir unseren Bestand in alphabetischer Reihenfolge. In regelmäßigen Abständen stellen wir deshalb in dieser Crowdsourcing-Aktion neue Briefstapel zur Verfügung, bis wir bei den Schreiber*innen, deren Nachnamen mit Z beginnen, angekommen sind. Sobald die Digitalisierung abgeschlossen ist, werden hier alle Briefe von A bis Z enthalten sein.</p>',
		},
		{
			title: 'Wie wird das Ranking erstellt?',
			description:
				'<p>Das Ranking der Beiträger*innen basiert auf der Zählung von Beiträgen zur Transkription eines Briefes und von Bestätigungen fertig transkribierter Briefe. Für jeden Brief, an dem (mit)transkribiert wurde, bekommen die Beiträger*innen einen Punkt. Für jede Bestätigung einer Version bekommen die Beiträger*innen einen Punkt. Die Punkte für Transkriptionen und Bestätigungen werden zusammengezählt, allerdings getrennt angezeigt.</p>',
		},
		{
			title: 'Was passiert mit den Transkriptionen?',
			description:
				'<p>Die transkribierten Texte werden nach Projektende in die <a href="https://www.digital.wienbibliothek.at/" target="_blank" rel="noreferrer">digitale Bibliothek</a> der Wienbibliothek im Rathaus übernommen. Dort werden sie langfristig gesichert und durchsuchbar gemacht.</p>',
		},
		{
			title: 'Was brauche ich, um ein Benutzer*innen-Konto anzulegen?',
			description:
				'<p>Sie brauchen eine E-Mail-Adresse, an die wir Ihnen einen Aktivierungslink schicken. Gleichzeitig wählen Sie Ihren öffentlich sichtbaren Benutzer*innen-Namen und Ihr Passwort.</p>',
		},
		{
			title: 'Wie kann ich mein Konto löschen?',
			description:
				'<p>Wenn Sie Ihr Konto löschen wollen, kontaktieren Sie uns bitte unter: <a href="mailto:crowdsourcing@wienbibliothek.at">crowdsourcing@wienbibliothek.at</a>. Ihre Beiträge bleiben erhalten.</p>',
		},
		{
			title: 'Wie kann ich bei Fragen Kontakt aufnehmen?',
			description:
				'<p>Bei Fragen zur Crowdsourcing-Aktion der Wienbibliothek im Rathaus kontaktieren Sie uns gerne unter: <a href="mailto:crowdsourcing@wienbibliothek.at">crowdsourcing@wienbibliothek.at</a>.</p>',
		},
		{
			title: 'Wie kann ich einen Kommentar hinzufügen?',
			description:
				'<p>Einen Kommentar können Sie im Transkriptionsmodus hinzufügen, indem Sie rechts unten auf „Kommentar hinzufügen“ klicken.</p><p>Dadurch ist es möglich anderen Beiträger*innen etwas mitzuteilen, falls es z.B. Unklarheiten bei der Transkription gibt oder die jeweilige Handschrift Besonderheiten aufweist.</p><p>Wurde zu einer Transkription ein Kommentar abgegeben, erkennen Sie das am Sprechblasen-Symbol neben den Informationen zur Transkription (<i>Erstellt von ...</i>). Mit einem Klick auf die Sprechblase können Sie den Kommentar lesen.</p>',
		},
		{
			title: 'Wie kann ich die Benachrichtigungen ausschalten?',
			description:
				'Ob oder welche Benachrichtigungen Sie erhalten, können Sie individuell im Profil unter dem Reiter „Einstellungen“ auswählen. Sie erhalten Benachrichtigungen ausschließlich in Ihrem Crowdsourcing-Profil online und nicht als E-Mail.',
		},
	];

	onMount(() => {
		$siteTitle = 'FAQ';
	});
</script>

{#each items as item}
	<details>
		<summary><span>{item.title}</span></summary>
		<div class="flex mt-8 mb-10">
			<div class="lg:w-2/3 lg:mx-auto rte rte-nolimit">
				{@html item.description}
			</div>
		</div>
	</details>
{/each}
